import { node } from 'prop-types'
import {
  FlexGrid,
  Paragraph,
  StackView,
  Typography,
  Divider,
  Spacer,
  Box
} from '@telus-uds/components-web'
import useTranslate from '../../../../hooks/useTranslate'

const PriceBreakdownContainer = ({ children }) => {
  const translate = useTranslate()
  const headingLabel = (
    <Typography variant={{ size: 'large' }} testID="price-breakdown-heading">
      {translate('priceBreakdown.heading', true)}
    </Typography>
  )
  const applicableTaxesLabel = (
    <Typography variant={{ size: 'medium' }} testID="applicable-taxes-label">
      {translate('priceBreakdown.applicableTaxesLabel', true)}
    </Typography>
  )

  return (
    <Box left={{ xs: 0, md: 3 }}>
      <Spacer space={5} />
      <StackView space={2}>
        <FlexGrid gutter={false}>
          <FlexGrid.Row>
            {/* desktop view start */}
            <FlexGrid.Col xs={0} sm={12}>
              <Paragraph>
                {headingLabel} {applicableTaxesLabel}
              </Paragraph>
            </FlexGrid.Col>
            {/* desktop view end */}
            {/* mobile view start */}
            <FlexGrid.Col xs={12} sm={0}>
              <StackView direction="column">
                {headingLabel} {applicableTaxesLabel}
              </StackView>
            </FlexGrid.Col>
            {/* mobile view end */}
          </FlexGrid.Row>
        </FlexGrid>
        <Divider variant={{ decorative: true }} />
        {children}
      </StackView>
    </Box>
  )
}

export default PriceBreakdownContainer

PriceBreakdownContainer.propTypes = {
  children: node.isRequired
}
